import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ModalHeaderEnum } from '@enums/vendor.enums';
import { mobileDeviceCheck } from '@helpers/mobile-check.helper';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs';
import { ILoggedInUserViewModel } from 'src/app/model/common.model';
import { FilesService } from 'src/app/service/files.service';
import { CreateBusinessUnitViewModel } from 'src/app/service/getBusinessUnitById';
import { ItineraryService } from 'src/app/service/itinerary.service';
import { NoteService } from 'src/app/service/note.service';
import { ICityViewModel, StateViewModel } from 'src/app/service/state.model';
import { VendorService } from 'src/app/service/vendor.service';
import { AddressType, DefaultGUID, PriorityList } from '../../@shared/constants/Constant';
import { IServiceAreas } from '../../service/business-unit';

declare var $: any;

@Component({
  selector: 'app-editVendor',
  templateUrl: './editVendor.component.html',
  styleUrls: ['./editVendor.component.css'],
})
export class EditVendorComponent implements OnInit, OnChanges {
  @Output() valueChange = new EventEmitter();
  @Output() vendorListNames = new EventEmitter();
  @Input() chooseFile: any = [];
  @Input() isModelOpen: boolean;
  @Input() detail: any;
  @Input() selectedIndex: number;
  @Input() modalHeader: string;
  @Output() closeModel = new EventEmitter();
  @Input() isVehicleCreated: boolean;
  @ViewChild('fileInput') fileInput: ElementRef;

  private form: NgForm;
  protected vendorDetail: CreateBusinessUnitViewModel = {
    businessUnitId: DefaultGUID,
    parentBusinessUnitId: DefaultGUID,
    businessUnitType: 'Vendor',
    name: '',
    transportType: [],
    isContracted: true,
    priority: null,
    serviceArea: [
      {
        stateId: '',
        city: [],
      },
    ],
    contact: {
      contactId: DefaultGUID,
      emailId: '',
      phoneNumber: '',
      homeNumber: '',
      workNumber: '',
      lastUpdatedOn: new Date(),
      lastUpdatedBy: DefaultGUID,
      createdOn: new Date(),
      createdBy: DefaultGUID,
    },
    address: {
      addressId: DefaultGUID,
      streetAddress: '',
      city: '',
      stateId: '',
      zipcode: '',
      latitude: '',
      longitude: '',
      addressLocationType: null,
      isGlobal: true,
    },
    note: [],
    isNationwideEnabled: false,
  };
  protected cityList: ICityViewModel[] = [];
  protected stateList: StateViewModel[] = [];
  protected priorityList = PriorityList;
  protected searchText1: string = '';
  protected header: string;
  protected AddressType: string[] = AddressType;
  protected sortBy: string = 'createdBy';
  protected sortOrder: boolean = false;
  protected user: ILoggedInUserViewModel;
  protected dropdownSettings = {};
  protected isMobileDevice = true;
  protected vendorLoader = false;
  protected selectedState: string;
  protected transportType: any = [];
  protected selectedCities = [];
  protected vendorServiceArea = [
    {
      stateId: '',
      city: [],
      cityList: [],
    },
  ];
  protected fromValid = true;
  protected serviceType = [
    {
      check: true,
      type: 'Air',
    },
    {
      check: false,
      type: 'Ground',
    },
  ];
  protected copyArr = [];
  protected editAllFile1: boolean = false;
  protected url: string;
  protected selectedCategory: string = '';
  protected path: string = '';
  protected multipleFilePopup: any;
  protected multipleFileUpload: any;
  protected oldFile = [];
  protected deletedFile = [];
  protected vendorFile: any;

  constructor(
    private _toast: ToastrService,
    private vendorService: VendorService,
    private noteService: NoteService,
    private itineraryService: ItineraryService,
    private _fileService: FilesService,
  ) {}

  ngOnChanges(): void {
    this.user = JSON.parse(localStorage.getItem('user'));
    this.clearData();

    if (this.form?.submitted && this.modalHeader !== ModalHeaderEnum.EDIT) {
      this.form?.resetForm();
    }

    this.vendorLoader = false;
    this.oldFile = [];
    if (this.modalHeader == ModalHeaderEnum.EDIT) {
      this.transportType = this.detail.transportType;
      this.serviceType.forEach((item) => {
        item.check = false;
      });

      this.vendorDetail = {
        businessUnitId: this.detail.businessUnitId,
        parentBusinessUnitId: DefaultGUID,
        businessUnitType: 'Vendor',
        name: this.detail.name,
        transportType: [],
        isContracted: this.detail.isContracted,
        priority: this.detail.priority,
        serviceArea: [],
        contact: {
          contactId: DefaultGUID,
          emailId: this.detail.emailID,
          phoneNumber: this.detail.phoneNumber,
          homeNumber: '',
          workNumber: '',
          lastUpdatedOn: new Date(),
          lastUpdatedBy: DefaultGUID,
          createdOn: new Date(),
          createdBy: DefaultGUID,
        },
        address: {
          addressId: this.detail.address.addressId,
          streetAddress: this.detail.address.streetAddress,
          addressLocationType: this.detail.address.addressLocationType,
          isGlobal: this.detail.address.isGlobal,
          city: this.detail.address.city,
          stateId: this.detail.address.stateId,
          zipcode: this.detail.address.zipcode,
          latitude: this.detail.address.latitude,
          longitude: this.detail.address.longitude,
        },
        note: [],
        isNationwideEnabled: this.detail.isNationwideEnabled,
      };
      this.noteService
        .getAllServiceRequestLevelNote(this.detail.businessUnitId, this.user.businessUnitId)
        .pipe(take(1))
        .subscribe((response) => {
          this.vendorDetail.note = response;
        });
      this.fillServiceArea();
      this.serviceType.forEach((item) => {
        item.check = this.detail.transportType?.includes(item.type) || false;
      });
      if (this.detail.address.stateId) {
        this.vendorService
          .getCityByState(this.detail.address.stateId)
          .pipe(take(1))
          .subscribe((response) => {
            this.cityList = response;
          });
      }
    } else {
      this.clearData();
    }
  }

  ngOnInit(): void {
    this.isMobileDevice = mobileDeviceCheck();
    this.getStateList();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'cityId',
      textField: 'cityName',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
  }

  /**
   * Resets service areas array if 'isNationwide' checkbox is checked
   * @param isNationwideChecked If the checkbox is checked
   */
  onIsNationwideToggle(isNationwideChecked: boolean): void {
    if (isNationwideChecked) {
      this.vendorServiceArea = [
        {
          stateId: '',
          city: [],
          cityList: [],
        },
      ];
    }
  }

  onSelectAll(event) {}

  private getStateList(): void {
    this.vendorService
      .getStateList()
      .pipe(take(1))
      .subscribe(
        (response) => {
          this.stateList = response;
        },
        (error) => {
          console.log(error);
        },
      );
  }

  private resetForm(f: NgForm): void {
    if (this.modalHeader != ModalHeaderEnum.EDIT) f.resetForm();
  }

  protected getCityByState(stateId: string): void {
    this.selectedState = this.stateList.find((x) => x.stateId == stateId).stateName;
    this.vendorService
      .getCityByState(stateId)
      .pipe(take(1))
      .subscribe((response) => {
        this.cityList = response;
      });
  }

  private fillServiceArea(): void {
    this.detail.serviceArea.forEach(async (item, index) => {
      if (this.detail.serviceArea.length - 1 > index) {
        this.addServiceArea();
      }
      this.vendorServiceArea[index].stateId = item.stateId;
      await new Promise<any[]>((resolve) => {
        this.vendorService
          .getCityByState(item.stateId)
          .pipe(take(1))
          .subscribe((cityListResponse) => {
            resolve(cityListResponse);
          });
      }).then((cityList) => {
        this.vendorServiceArea[index].cityList = cityList;
        this.selectedCities = [];
        item.city.forEach((cityName) => {
          const city = this.vendorServiceArea[index].cityList.find((city) => city.cityName === cityName);
          if (city != undefined) {
            this.selectedCities.push(city);
          }
        });
        this.vendorServiceArea[index].city = this.selectedCities;
      });
    });
  }

  protected closeVendorModel(formData: NgForm): void {
    this.closeModel.emit();
    this.clearData();
    this.resetForm(formData);
  }
  protected addServiceArea(): void {
    this.vendorServiceArea.push({
      stateId: '',
      city: [],
      cityList: [],
    });
  }

  protected removeServiceArea(index: number): void {
    this.vendorServiceArea.splice(index, 1);
  }

  protected selectState(event, index: number): void {
    this.vendorServiceArea[index].city = [];
    this.vendorServiceArea[index].stateId = event.target.value;
    this.vendorService
      .getCityByState(event.target.value)
      .pipe(take(1))
      .subscribe((response) => {
        this.vendorServiceArea[index].cityList = response;
      });
  }

  protected submitVendorData(formData: NgForm): void {
    this.form = formData;
    this.fromValid = true;
    this.vendorDetail.transportType = [];
    this.serviceType.filter((x) => {
      if (x.check == true) this.vendorDetail.transportType.push(x.type);
    });
    if (this.vendorDetail.transportType.length == 0) this.fromValid = false;
    if (formData.form.valid && this.vendorDetail.transportType.length > 0) {
      $('#vendorDetail').modal('hide');
      this.vendorLoader = true;

      if (this.vendorServiceArea.length && !!this.vendorServiceArea[0].stateId) {
        this.vendorDetail.serviceArea = this.vendorServiceArea.map(
          ({ stateId, city }: { stateId: string; city: ICityViewModel[] }): IServiceAreas => ({
            stateId,
            city: city.map((selectedCity) => selectedCity.cityName),
          }),
        );
      }

      this.vendorDetail.contact.phoneNumber = this.vendorDetail.contact.phoneNumber.replace(/[^0-9\s]/g, '');
      this.vendorDetail.contact.phoneNumber = this.vendorDetail.contact.phoneNumber.replace(/\s/, '');
      if (this.modalHeader == ModalHeaderEnum.ADD) {
        let tempThis = this;
        let countryName = 'USA';
        let address =
          this.vendorDetail.address.streetAddress +
          ', ' +
          this.vendorDetail.address.city +
          ', ' +
          this.selectedState +
          ' ' +
          countryName +
          ' ' +
          this.vendorDetail.address.zipcode;
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode(
          {
            address: address,
          },
          function (results, status) {
            if (status == 'OK') {
              let longitude = results[0].geometry.location.lng();
              let latitude = results[0].geometry.location.lat();
              if (longitude && latitude) {
                tempThis.vendorDetail.address.latitude = latitude.toString();
                tempThis.vendorDetail.address.longitude = longitude.toString();
              }
              tempThis.createVendor(formData);
            } else {
              tempThis.createVendor(formData);
            }
          },
        );
      } else {
        if (this.transportType && this.vendorDetail.transportType[0] != this.transportType[0] && this.isVehicleCreated == true) {
          if (confirm('Are you sure you want to change the transport type? Your data may be lost')) {
            this.editVendor(formData);
          } else {
            this.vendorLoader = false;
          }
        } else {
          this.editVendor(formData);
        }
      }
    }
  }

  private createVendor(event): void {
    this.vendorService
      .createVendor(this.vendorDetail)
      .pipe(take(1))
      .subscribe(
        (response) => {
          event.resetForm();
          this.vendorListNames.emit();
          this.multipleFileAttach(response, this.chooseFile, 'member');
        },
        (err) => {
          event.resetForm();
          this.vendorLoader = false;
          this._toast.warning('Something went wrong! Please try again', 'Warning', {
            timeOut: 6000,
            positionClass: 'toast-top-center',
          });
          this.vendorLoader = false;
        },
      );
    this.clearData();
    this.vendorLoader = false;
  }

  protected editVendor(form: NgForm): void {
    this.vendorService
      .updateVendorDetail(this.vendorDetail.businessUnitId, this.vendorDetail)
      .pipe(take(1))
      .subscribe(
        (response) => {
          this.submitVendorMultipleFile();
        },
        (err) => {
          console.log(err);
          form.resetForm();
          this.vendorLoader = false;
          this._toast.warning('Something went wrong! Please try again', 'Warning', {
            timeOut: 6000,
            positionClass: 'toast-top-center',
          });
        },
      );
  }

  protected fileEdit(index: number): void {
    this.copyArr = [...this.chooseFile].map((item) => ({ ...item }));
    this.chooseFile[index].IsEditable = true;
  }

  protected editVendorFileOpen(): void {
    $('#vendorFileUpdate').click();
  }

  protected closeDisable(index: number): void {
    this.chooseFile[index].IsEditable = false;
    let arr = this.chooseFile.map((x) => x.IsEditable);
    if (arr.indexOf(true) == -1) this.editAllFile1 = false;
  }

  protected editAllFile(): void {
    this.copyArr = [...this.chooseFile];
    this.chooseFile.forEach((item) => {
      item.IsEditable = true;
    });
    this.editAllFile1 = true;
  }

  protected closeViewFileModel(): void {
    this.chooseFile.forEach((item) => {
      item.IsEditable = false;
    });
    this.editAllFile1 = false;
  }

  protected closeAll(): void {
    this.chooseFile = this.copyArr;
    this.editAllFile1 = false;
  }

  private successMessage(msg: string): void {
    this._toast.success(msg, 'Success!', {
      timeOut: 2000,
      positionClass: 'toast-top-center',
    });
  }

  private clearData(): void {
    this.vendorDetail = {
      businessUnitId: DefaultGUID,
      parentBusinessUnitId: DefaultGUID,
      businessUnitType: 'Vendor',
      name: '',
      transportType: [],
      isContracted: true,
      priority: null,
      serviceArea: [],
      contact: {
        contactId: DefaultGUID,
        emailId: '',
        phoneNumber: '',
        homeNumber: '',
        workNumber: '',
        lastUpdatedOn: new Date(),
        lastUpdatedBy: DefaultGUID,
        createdOn: new Date(),
        createdBy: DefaultGUID,
      },
      address: {
        addressId: DefaultGUID,
        streetAddress: '',
        city: '',
        stateId: '',
        zipcode: '',
        latitude: '',
        longitude: '',
        addressLocationType: null,
        isGlobal: true,
      },
      note: [],
      isNationwideEnabled: false,
    };
    this.serviceType = [
      {
        check: true,
        type: 'Air',
      },
      {
        check: false,
        type: 'Ground',
      },
    ];
    this.vendorServiceArea = [
      {
        stateId: '',
        city: [],
        cityList: [],
      },
    ];
  }

  protected vendorFileUpload(name, fileId): void {
    let tempFileList = $('#' + fileId)[0].files;
    let tempFileListArray = Array.from(tempFileList);
    tempFileListArray.forEach((file) => {
      file['fileId'] = 0;
      file['fileType'] = ' ';
      file['displayName'] = file['name'];
      file['extension'] = file['type'].split('/')[1];
      file['fileName'] = file['name'].split('.')[0];
      file['IsEditable'] = false;
      this.chooseFile.push(file);
    });
    this.fileInput.nativeElement.value = '';
  }

  private multipleFileAttach(memberId, fileList, flag?): void {
    if (fileList.length != 0) {
      this.path = '';
      this.multipleFileUpload = new FormData();
      fileList.forEach((item) => {
        this.path = this.path.concat(item.fileType + ',');
        this.multipleFileUpload.append(item.name, item);
      });
      this.path = this.path.replace(/,(?=\s*$)/, '');
      this._fileService
        .uploadFile(this.path, 'Vendor', memberId, this.multipleFileUpload)
        .pipe(take(1))
        .subscribe(
          (response) => {
            if (flag == 'member') {
              this.vendorLoader = false;
              this.successMessage('Added Vendor Successfully');
              this.valueChange.emit();
            } else {
              this.editFile();
            }
          },
          (error) => {
            this.vendorLoader = false;
            this._toast.warning('Something went wrong! Please try again', 'Warning', {
              timeOut: 6000,
              positionClass: 'toast-top-center',
            });
            this.vendorLoader = false;
          },
        );
    } else {
      this.editFile();
    }
  }

  private submitVendorMultipleFile(): void {
    this.oldFile = [];
    this.chooseFile.forEach((item) => {
      item['displayName'] = item['fileName'] + '.' + item['extension'];
      if (item.fileId != 0) {
        this.oldFile.push({
          fileId: item.fileId,
          fileName: item.displayName,
          fileType: item.fileType,
        });
      }
    });
    let newFile = this.chooseFile.filter((x) => x.fileId == 0);
    this.multipleFileAttach(this.detail.businessUnitId, newFile);
  }

  private deleteFile(): void {
    if (this.deletedFile.length != 0) {
      let deleteFile = '';
      this.deletedFile.forEach((item) => {
        deleteFile = deleteFile + 'fileId=' + item.fileId + '&';
      });
      deleteFile = deleteFile.slice(0, -1);
      this.vendorService
        .deletedFile(deleteFile)
        .pipe(take(1))
        .subscribe((response) => {
          this.deletedFile = [];
          this.vendorLoader = false;
        });
    } else {
      this.vendorLoader = false;
      this.successMessage('Updated Vendor Successfully');
      this.valueChange.emit();
    }
  }

  private editFile(): void {
    if (this.oldFile.length != 0) {
      this.vendorService
        .editFile(this.oldFile)
        .pipe(take(1))
        .subscribe((response) => {
          this.oldFile = [];
          this.deleteFile();
        });
    } else {
      this.deleteFile();
    }
  }

  protected removeFileForPopup(index: number): void {
    if (this.chooseFile[index].fileId != 0) this.deletedFile.push(this.chooseFile[index]);
    this.chooseFile.splice(index, 1);
    this._toast.success('Removed File Successfully!', 'Success', {
      timeOut: 6000,
      positionClass: 'toast-top-center',
    });
  }

  protected downloadFile(file): void {
    if (file.fileName != undefined) {
      var a = document.createElement('a');
      document.body.appendChild(a);
      a.href = file.filePath;
      a.download = file.displayName;
      a.click();
      document.body.removeChild(a);
    }
  }
}
